
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { batchReview } from '@/api/task/exOrder'
import { delObjEmptyKey } from '@/utils'

@Component({
  name: 'batchReview',
  components: {}
})
export default class extends Vue {
  private loading: boolean = false
  private setForm: any = {
    start: '',
    end: '',
    status: null
  }
  private listForm: any = {}
  private orderList: any = []

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  validateStart = (rule, value, callback) => {
    if (this.setForm.end) {
      ;(this.$refs.setForm as ElForm).validateField('end')
    }
    callback()
  }

  validateEnd = (rule, value, callback) => {
    if (this.setForm.start) {
      if (Number(this.setForm.start) <= Number(value)) {
        callback()
      } else {
        callback(new Error('The End ID must be greater than the Start ID'))
      }
    } else {
      callback()
    }
  }

  private rules: any = {
    start: [
      { required: true, message: 'Please input Start ID', trigger: 'blur' },
      { validator: this.validateStart, trigger: 'blur' }
    ],
    end: [
      { required: true, message: 'Please input End ID', trigger: 'blur' },
      { validator: this.validateEnd, trigger: 'blur' }
    ],
    status: [
      { required: true, message: 'Please select status', trigger: 'blur' }
    ]
  }

  private back () {
    this.$emit('close')
  }

  private async confirm () {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data = {
            ...this.setForm
          }
          delObjEmptyKey(data)
          await batchReview(data).then((res: any) => {
            this.$message({
              message: 'Approval successfully!',
              type: 'success'
            })
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }
}
